export const languageConstants = {
  andromeda: ["en", "es", "jp", "pt"],
  bolerus: ["es", "gl"],
  casiopea: ["en", "es", "ca"],
  draco: ["es", "eu", "fr", "en"],
  indus: ["es", "eu", "fr", "en"],
  eudora: ["es", "gl", "en"],
  gemini: ["es", "gl", "en"],
  kennicut: ["es", "en", "ca"],
  pegaso: ["gl", "es"],
  perseo: ["es", "en", "gl"],
  petisgo: ["es", "gl"],
  tiivii: ["en", "es", "gl"],
};
